import { useEffect } from "react";

const PORTAL_TITLE = "Clinician Portal | Education For All";
const PORTAL_FAVICON = "/EduForAll.png?brand=clinician-portal-v1";

export function PortalDocumentBranding() {
  useEffect(() => {
    const previousTitle = document.title;
    let favicon = document.querySelector<HTMLLinkElement>('link[rel~="icon"]');
    const createdFavicon = !favicon;

    if (!favicon) {
      favicon = document.createElement("link");
      favicon.rel = "icon";
      document.head.appendChild(favicon);
    }

    const previousHref = favicon.getAttribute("href");
    const previousType = favicon.getAttribute("type");
    const previousSizes = favicon.getAttribute("sizes");

    document.title = PORTAL_TITLE;
    favicon.setAttribute("href", PORTAL_FAVICON);
    favicon.setAttribute("type", "image/png");
    favicon.setAttribute("sizes", "256x256");

    return () => {
      document.title = previousTitle;

      if (createdFavicon) {
        favicon?.remove();
        return;
      }

      if (previousHref === null) favicon?.removeAttribute("href");
      else favicon?.setAttribute("href", previousHref);

      if (previousType === null) favicon?.removeAttribute("type");
      else favicon?.setAttribute("type", previousType);

      if (previousSizes === null) favicon?.removeAttribute("sizes");
      else favicon?.setAttribute("sizes", previousSizes);
    };
  }, []);

  return null;
}
